<template>
  <div :id="id" :style="{height:height,width:width}"></div>
</template>

<script>
import * as echarts from 'echarts'
import resize from '../mixins/resize'

export default {
  name: "pieChart",
  mixins: [resize],

  props: {
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    statusType: {
      type: String,
      default: 'peiData'
    },
    data: {
      type: Array,
      default () {
        return [];
      }
    },
    color: {
      type: Array,
      default () {
        return [];
      }
    },
  },
  data () {
    return {
      chart: null,
      pieData1: '',
      pieData2: '',
      lockPercent1: 0,
      lockPercent2: 0,
    }
  },
  mounted () {
    this.initPieChart()

    // this.timer = setTimeout(() => {   //设置延迟执行
    //   this.initPieChart()
    // }, 600)
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initPieChart () {
      this.chart = echarts.init(document.getElementById(this.id))
      this.chart.setOption({
        color: ['#D03776', '#848ca4'],
        // tooltip: {
        //   show: false,
        //   trigger: 'item',
        //   formatter: "{b} : {c} ({d}%)"
        // },
        // legend: {
        //   icon: 'roundRect',
        //   type: 'scroll',
        //   textStyle: { //图例文字的样式
        //     color: '#FFF',
        //     fontSize: 12
        //   },
        //   orient: 'vertical',
        //   bottom: -6,
        //   left: 0,
        //   data: this.data[1],
        //   itemWidth: 10,
        //   itemHeight: 10,
        //   formatter: function (param) {
        //     var total = 0;
        //     for (var i = 0; i < data1.length; i++) {
        //       total += data1[i].value;
        //     }
        //     for (i = 0; i <br data1.length; i++) {
        //       var dpercent = (data1[i].value / total * 100).toFixed(2) + '%'
        //       if (data1[i].name === param) {
        //         return param.toString().split(":")[0] + ' : ' + dpercent
        //       }
        //     }
        //   }
        // },
        // grid: {
        //   left: '10%',
        //   right: '4%',
        //   bottom: '10%',
        //   containLabel: true
        // },
        // title: {
        //   show: true,
        //   text: '在线率',
        //   // subtext: '{d}',
        //   textStyle: {
        //     color: '#fff',
        //     fontSize: 12
        //   },
        //   top: '25%',
        //   left: 'center'
        // },
        series: [{
          type: 'pie',
          center: ["50%", "50%"],
          radius: ['70%', '90%'],
          stillShowZeroSum: true,
          label: {
            position: 'center',
            color: '#fff',
            // show: false,
            // formatter: function (params) {
            //   return params.value == 0 ? '0%' : params.percent + '%';
            // },
            formatter:
              [
                '{a|在线率\n}',
                '{b|{d}%}'
              ].join('\n')
            ,
            rich: {
              a: {
                color: '#fff',
                fontSize: 12
              },
              b: {
                color: '#fff',
                fontSize: 20
              }
            },
          },
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 0,
          },
          labelLayout: {
            draggable: true,
          },
          labelLine: {
            show: false
          },
          emphasis: {
            show: true,
            label: {
              show: false
            },
            scale: true,
            scaleSize: 1,
          },
          data: this.data[0]
        }]
      })
    },
    dispose () {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    }
  }
}
</script>

<style scoped>
</style>
